import { render } from "./action_reaction.vue?vue&type=template&id=93310108&scoped=true&ts=true"
import script from "./action_reaction.vue?vue&type=script&lang=ts"
export * from "./action_reaction.vue?vue&type=script&lang=ts"

import "./action_reaction.vue?vue&type=style&index=0&id=93310108&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93310108"]])

export default __exports__